'use client';

import { PublicEnvVarsContext } from '@/providers/PublicEnvVarsProvider';
import { useContext } from 'react';

const usePublicEnvVars = () => useContext(PublicEnvVarsContext);

export default usePublicEnvVars;
